//
// Filter functionality
//

$(function() {
    
    // Focus at top of checkbox collapse because the toggle is under said collapse
    $('.input-group-collapse').each(function() {
        $(this).on('shown.bs.collapse', function() {
            $(this)
                .focus()
                .blur();
        });
    });

    // Check if filters are being used
    function filtersUsed(el, activeClass) {
        var filtersApplyButton = el.find('.filters__apply-btn'),
            selectedAmount = el.find('option:selected').filter(function() {
                return $(this).val();
            }).length,
            checkedAmount = el.find('[type="checkbox"]:checked').length;

        if (!selectedAmount && !checkedAmount) {
            filtersApplyButton.removeClass(activeClass);
        } else {
            filtersApplyButton.addClass(activeClass);
        }
    }

    // Apply button styling if filters are interacted with
    $('.filters').each(function() {
        var $filters = $(this);

        $filters.find(':input').on('change', function() {
            filtersUsed($filters, 'js-active');
        });
    });
});